<template>
     <div class="filter-item" @click.stop="handleItemClick"><slot/></div>
</template>

<script>
export default {
  name: 'filters-item',
  methods: {
    handleItemClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/filters-item.vue